const styles = (theme) => ({
  heading: {
    borderBottom: '1px solid #3c3c3c',
    marginBottom: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 1.75,
    fontSize: '1.625rem',
    color: theme.palette.text.dark,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.unit * 4,
      fontSize: '2rem',
    },
  },
  subHeading: {
    marginBottom: theme.spacing.unit * 2,
    fontSize: '1.5rem',
    color: theme.palette.text.dark,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.unit * 3,
      fontSize: '1.6875rem',
    },
  },
});

export default styles;
